const withRenderedMain = require('components-framework/view/with_rendered_main');
const BaseView = require('components-framework/view/base.view');
const isMobile = Odigeo.SessionScope.flow === 'mobile';
const stopDetailsItemFactory = isMobile
    ? require('components/flights/stop_details_item/js/main.mobile')
    : require('components/flights/stop_details_item/js/main.desktop');

const hubItemFactory = require('components/flights/hub_item/js/main');

const hasAirlineChanged = (previousSection, section) => {
    return previousSection.carrier.code !== section.carrier.code;
};

const hasAirportChanged = (previousSection, section) => {
    return previousSection.arrivalLocation.geoNodeId !== section.departureLocation.geoNodeId;
};

const hasAirportOrTrainStationChanged = (previousSection, section) => {
    return (previousSection.arrivalLocation.geoNodeId !== section.departureLocation.geoNodeId)
        || (previousSection.flight !== section.flight);
};

const hasTerminalChanged = (previousSection, section) => {
    return !hasAirportChanged(previousSection, section)
            && !Odigeo._.isEmpty(previousSection.arrivalTerminal)
            && !Odigeo._.isEmpty(section.departureTerminal)
            && previousSection.arrivalTerminal !== section.departureTerminal;
};

const createStopDetailItem = (shouldShowVisa, el, visaText, text, icon, size, color = '') => {
    const options = {shouldShowVisa, visaText, text, icon, size, color};
    return stopDetailsItemFactory.create({el, options});
};

module.exports = withRenderedMain(BaseView.extend({
    selectors: {
        stopInfoHub: '.hub_or_smarthub',
    },

    initialize({options}) {
        this.options = options;
        this.keys = options.keys;
        this.render();
    },

    render() {
        if (Odigeo.AB.isNewTripDetails) {
            this.renderNewTripDetails();
        } else {
            this.renderDefault();
        }

        if (this.options.isHub) {
            this.renderHub();
            this.options.isTravelRestrictionMessage && this.restrictionMessage();
        } else {
            createStopDetailItem(this.shouldShowVisaMessage(), this.$el.find('.hub_or_smarthub'),
                this.keys.visaRequirements,
                this.keys.missedConnection,
                'odf-icon-shield',
                this.options.size);
        }
    },

    shouldShowVisaMessage() {
        return this.options.isTravelRestrictionMessage && !this.options.showChangeOfCarrier && Odigeo.AB.isVisaRegulationsDE;
    },

    renderDefault() {
        if (hasAirportChanged(this.options.previousSection, this.options.section)) {
            createStopDetailItem(
                false,
                this.$el.find('.airport_changed'),
                this.keys.visaRequirements,
                this.options.flight ? this.keys.airportChange : this.keys.stationChange,
                'odf-icon-man-baggage-walking',
                this.options.size
            );
        }
        if (hasTerminalChanged(this.options.previousSection, this.options.section)) {
            createStopDetailItem(false, this.$el.find('.terminal_changed'),
                this.keys.visaRequirements,
                this.keys.terminalChange,
                'odf-icon-man-baggage-walking',
                this.options.size);
        }
        if (hasAirlineChanged(this.options.previousSection, this.options.section)) {
            createStopDetailItem(
                false,
                this.$el.find('.airline_changed'),
                this.keys.visaRequirements,
                this.options.flight ? this.keys.airlineChange : this.keys.trainChange,
                this.options.flight ? 'odf-icon-flight-right' : 'odf-icon-train-right',
                this.options.size
            );
        }
    },

    renderNewTripDetails() {
        if (hasAirportOrTrainStationChanged(this.options.previousSection, this.options.section)) {
            createStopDetailItem(
                false,
                this.$el.find('.airport_changed'),
                this.keys.visaRequirements,
                this.options.section.flight ? this.keys.selfTransferToAirport : this.keys.selfTransferToTrainStation,
                this.options.section.flight ? 'odf-icon-flight-right' : 'odf-icon-train-right',
                this.options.size
            );
        }
        if (this.options.showChangeOfCarrier) {
            createStopDetailItem(
                false,
                this.$el.find('.airline_changed'),
                this.keys.visaRequirements,
                this.options.flight ? this.keys.airlineChange : this.keys.trainChange,
                this.options.flight ? 'odf-icon-flight-right' : 'odf-icon-train-right',
                this.options.size
            );
        }
    },

    vinMessageTemplate(title, message) {
        return `<span class="odf-strong">${title || ''}</span>${title && '<br />' || ''}${message}`;
    },

    restrictionMessage() {
        const message = this.vinMessageTemplate(this.keys.vinMessageStopInfoTitle, this.keys.vinMessageStopInfo);
        const textClass = Odigeo.AB.isNewTripDetails ? 'odf-text-info-dark' : 'odf-text-info';
        createStopDetailItem(
            this.$el.find('.restriction_message_title'), this.keys.visaRequirements,
            message, 'odf-icon-information', this.options.size, textClass
        );
    },

    renderHub() {
        return hubItemFactory.create({
            el: this.$el.find(this.selectors.stopInfoHub),
            hubInsurance: this.options.hubInsurance,
            keys: this.options.hubKeys,
        });
    },
}));
